<template>
  <div class="iconography-typo-content" id="identidade-visual-iconografia-aplicacoes" data-search-anchor>
    <div class="title-iconography-typo-wrapper">
      <h1 class="iconography-typo-title-span">{{ iconographyTypoUseColorsTitleSpan }}</h1>
      <h1 class="iconography-typo-title">{{ iconographyTypoUseColorsTitle }}</h1>
    </div>

    <div class="description-iconography-typo-wrapper">
      <p class="iconography-typo-description">{{ iconographyTypoUseColorsDescription }}</p>

        
      <div class="iconography-typo-icon-wrapper">
        <p class="importante">
          {{ iconographyTypoUseColorsDescription1 }}
        </p>
        
        <div class="wrapper-content-description">
          <IconCheck />
          <p class="iconography-typo-description-second-title">
            {{ iconographyTypoUseColorsDescription2 }}
          </p>
        </div>
        
      </div>
    </div>

    <div
      class="iconography-typo-card-item"
      :style="{ backgroundImage: `url(${iconographyTypoUseColorsImageSrc})` }"
    ></div>

    <div class="title-iconography-typo-wrapper">
          <h1 class="iconography-typo-title-span">{{ iconographyTypoUseColorsAplicacaoTitleSpan }}</h1>
          <h1 class="iconography-typo-title">{{ iconographyTypoUseColorsAplicacaoTitle }}</h1>
        </div>
    <div
      class="iconography-typo-card-item2"
      :style="{ backgroundImage: `url(${iconographyTypoUseColorsImageSrc2})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import IconographyPageMixin from '@/mixins/iconography-page-mixin'
import { IconographyPageStore } from '@/store/visual-identity-page/iconography-page'
import IconCheck from '@/assets/icons/IconCheck.vue'

@Component({
  components: { IconCheck }
})
export default class IconographyTypoUseColorsSection extends Mixins(IconographyPageMixin) {
  iconographyPageStore: PageStoreContract = getModule(IconographyPageStore, this.$store)

  get iconographyTypoUseColorsTitleSpan(): string {
    return this.getElementTitle(2, 0)
  }

  get iconographyTypoUseColorsTitle(): string {
    return this.getElementText(2, 0)
  }

  get iconographyTypoUseColorsDescription(): string {
    return this.getElementText(2, 1)
  }

  get iconographyTypoUseColorsDescription1(): string {
    return this.getElementText(2, 2)
  }

  get iconographyTypoUseColorsDescription2(): string {
    return this.getElementText(2, 3)
  }

  get iconographyTypoUseColorsImageSrc(): string {
    return this.getElementMedia(2, 4)
  }

  get iconographyTypoUseColorsImageSrc2(): string {
    return this.getElementMedia(2, 5)
  }
  
  get iconographyTypoUseColorsAplicacaoTitleSpan(): string {
    return this.getElementTitle(2, 5)
  }

  get iconographyTypoUseColorsAplicacaoTitle(): string {
    return this.getElementText(2, 5)
  }

  async getIconographyPage(): Promise<void> {
    await this.iconographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.iconographyPageStore.isLoading) {
      await this.getIconographyPage()
    }
  }
}
</script>

<style lang="scss">
.iconography-typo-content {
  display: grid;

  max-width: 1032px;
  width: 100%;  
}

.title-iconography-typo-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.iconography-typo-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.iconography-typo-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-iconography-typo-wrapper {
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%;  
}

.wrapper-content-description {
  display: flex;
  align-items: center;
}

.iconography-typo-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  margin: 0;  
  width: 430px;
}

.iconography-typo-description-second-title {
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  text-align: left;
  white-space: pre-line;
  
  padding-left: 7px;
  width: 395px;
}

.iconography-typo-description-second {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  margin: 0;
  padding-left: 7px;
  width: 484px;
}

.iconography-typo-card-item {
  position: relative;    

  max-width: 1032px;
  width: 100%;
  height: 705px;    

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.iconography-typo-card-item2 {
  position: relative;    

  max-width: 1032px;
  width: 100%;
  height: 525px;  
  margin-bottom: 2rem; 

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
